<div class="component-container">
  @if (btnMode) {
    <div class="button-logo-uploader" [class.disabled]="disabled">
      @if (!photoUrl) {
        <label [for]="disabled ? null : uniqueId" class="btn-area w-stretch" [class.has-file]="photoUrl" [style]="imageContainerStyle">
          <span class="text-center">
            @if (!photoUrl && !loading) {
              <img [src]="placeholderIcon.src" [width]="placeholderIcon.width" [height]="placeholderIcon.height" alt="" />
            }
            @if (loading) {
              <i class="pi pi-spin pi-spinner color-primary" style="font-size: 2rem"></i>
            }
            @if (!photoUrl && !loading) {
              <span class="btn-area-label">
                <i aria-hidden="true" class="icon icon-plus_o"></i>
                @if (label) {
                  <b>{{ label }}</b>
                }
                @if (!label) {
                  <b>{{ 'COMMON.BUTTONS.ADD_IMAGE' | translate }}</b>
                }
              </span>
            }
          </span>
          <input [disabled]="loading || disabled" type="file" accept="image/*" class="sr-only" (change)="onChange($event)" [id]="uniqueId" #inputEl />
        </label>
      }
      @if (photoUrl) {
        <div class="img-box btn-area w-stretch" [class.has-file]="photoUrl" [style]="imageContainerStyle" [class.not-clickable]="disabled">
          <span class="text-center">
            <div>
              <img [src]="photoUrl" [class.round]="!square" alt="" [width]="placeholderSelectedImage.width" [height]="placeholderSelectedImage.height" />
            </div>
            @if (photoUrl && !loading && !disabled) {
              <a href="#" class="btn-area-label" (click)="reset($event)">
                <i aria-hidden="true" class="icon icon-trash mr-5"></i> <b>{{ 'COMMON.BUTTONS.DELETE' | translate }}</b>
              </a>
            }
          </span>
        </div>
      }
    </div>
  }

  @if (!btnMode) {
    <div class="avatar-uploader" [class.square]="square" [class.isnew]="!photoUrl" [class.disabled]="disabled">
      <input [disabled]="loading || disabled" type="file" accept="image/*" class="sr-only" (change)="onChange($event)" [id]="uniqueId" #inputEl />
      <label [for]="disabled ? null : uniqueId" class="photo-area" [class.not-clickable]="disabled">
        @if (photoUrl) {
          <img [src]="photoUrl" [class.round]="!square" alt="" />
        }
        @if (!photoUrl && !loading) {
          <i class="icon icon-photo"></i>
        }
        @if (loading) {
          <i class="pi pi-spin pi-spinner color-primary" style="font-size: 2rem"></i>
        }
      </label>
      @if (!loading && !photoUrl && !disabled) {
        <label [for]="uniqueId" pButton pRipple icon="icon icon-photo" class="p-button-rounded"></label>
      }
      @if (photoUrl && !loading && !disabled) {
        <button
          type="button"
          (click)="reset($event)"
          pButton
          pRipple
          icon="icon icon-close_circle_outline"
          [attr.aria-label]="'COMMON.BUTTONS.REMOVE_IMAGE' | translate"
          class="p-button-rounded"
        ></button>
      }
    </div>
  }
</div>
